import { NoImage } from "@assets/constant/index.constant";
import { endpoint } from "@services/api.services";
import Tooltip from "@ui/external/components/tooltip";
import { ZoomImage } from "@ui/internal/components/formelement";
import { getFileIcon, showToast } from "@utils/helper/index.helper";
import { useHandleAction } from "@utils/hook/index.hook";
import { useSelectionStore } from "@utils/states/index.state";
import { Copy, CopyPlus, CopyPlusIcon } from "lucide-react";
import React, { useMemo } from "react";
import { Link } from "react-router";

const ColumnList = ({ refetch }: { refetch?: () => void }) => {
  const BucketEndpoint = useMemo(() => endpoint["uploadimage"], []);
  const { clearSelection } = useSelectionStore();
  console.log("Success", BucketEndpoint);
  const { handleAction } = useHandleAction({
    endpoint: BucketEndpoint,
    refetch,
  });
  const columns = useMemo(
    () => [
      {
        name: "ID",

        cell: (row: any) => (
          <span className="font-semibold text-gray-700">{row.id}</span>
        ),
        sortable: true,
      },

      {
        name: "File",
        cell: (row: any) => {
          const Icon = getFileIcon(row?.image);
          return (
            <div className="flex items-center  gap-2  w-full h-full">
              {/* <div className=" bg-[#1daa7e] size-6 text-white rounded-sm flex items-center justify-center text-center text-[12px]">
                <Icon size={16} />
              </div> */}
              {/* <div className="max-w-[110px] w-fit truncate">
                {row?.image?.split("/").pop()}
              </div> */}
              <img
                src={row?.image || NoImage}
                className="h-20 w-20 object-contain"
              />
            </div>
          );
        },
        sortable: true,
      },
      {
        name: "Link",
        cell: (row: any) => (
          <div className="flex items-center gap-4 w-full h-full">
            {row?.image ? (
              <div className="flex gap-4">
                <Tooltip description={row?.image}>
                  <Link
                    to={row?.image}
                    target="_blank"
                    className="truncate max-w-[150px] w-fit"
                  >
                    {row?.image}
                  </Link>
                </Tooltip>
                <Tooltip description={"Copy Link"}>
                  <span className="size-6 flex justify-center items-center rounded-full bg-[#1a926c] text-white">
                    {" "}
                    <Copy
                      size={15}
                      onClick={() => {
                        window.navigator.clipboard.writeText(row?.image);
                        showToast({
                          description: "Image Link Copied",
                          title: "Success",
                          type: "success",
                        });
                      }}
                    />
                  </span>
                </Tooltip>
              </div>
            ) : (
              "N/A"
            )}
          </div>
        ),
        sortable: true,
      },

      {
        name: "Actions",
        cell: (row: any) => (
          <div className="flex items-center gap-3 cursor-pointer font-[500] select-none">
            <button
              className="text-[#C33241] cursor-pointer"
              onClick={() => {
                clearSelection();
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row.id },
                });
              }}
              title="Delete"
            >
              Delete
            </button>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction, clearSelection]
  );
  return columns;
};

export { ColumnList };
